import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import { CAPTCHA_SITE_KEY } from '../constants/config';
import { Outlet } from 'react-router-dom';
import QuizAuthGuard from './QuizAuthGuard';

const QuizLayout = () => {
  if (!CAPTCHA_SITE_KEY) {
    return <Outlet />;
  }

  return (
    <GoogleReCaptchaProvider reCaptchaKey={CAPTCHA_SITE_KEY} language="sr">
      <QuizAuthGuard text="Prijavi se kako bi učestvovao u kvizu">
        <Outlet />
      </QuizAuthGuard>
    </GoogleReCaptchaProvider>
  );
};

export default QuizLayout;
